import { SUPPORTED_UNITS_SCHEMA } from '../../quote-unit/unit-types';
import { z } from 'zod';

const TrentStatusSchema = z.enum(['ACTIVE', 'INACTIVE']);

export const TRENT_MATERIAL_SUPPORTED_UNITS_SCHEMA = SUPPORTED_UNITS_SCHEMA.extract([
    'KILOGRAM',
    'TON',
    'CUBIC_METER',
    'LITER',
    'PIECE',
]);

const AddressSchema = z.object({
    street: z.string(),
    addressNumber: z.string().nullable(),
    zip: z.string(),
    city: z.string(),
    country: z.string(),
});

const ClientOrganizationSchema = z.object({
    id: z.number(),
    name: z.string(),
    address: AddressSchema,
    vatNumber: z.string(),
});

const ContactSchema = z.object({
    name: z.string(),
    phone: z.string(),
});

const LocationSchema = z.object({
    address: AddressSchema,
    maximumTrafficability: z.number(),
});

const MaterialSchema = z.object({
    name: z.string(),
    isDisposal: z.boolean(),
    quota: z.number(),
    unit: TRENT_MATERIAL_SUPPORTED_UNITS_SCHEMA,
    salesPrice: z.number(),
    currency: z.string(),
});

const TransportSchema = z.object({
    name: z.string().optional(),
    quota: z.number(),
    unit: z.string(),
    salesPrice: z.number(),
    currency: z.string(),
    carrierId: z.number(),
});

const ProjectSchema = z.object({
    projectNumber: z.string().trim().nonempty(),
    name: z.string().trim().nonempty(),
    validFrom: z.string().datetime(),
    validTo: z.string().datetime(),
    status: TrentStatusSchema,
    clientOrganization: ClientOrganizationSchema,
    address: AddressSchema,
    contact: ContactSchema,
    salesManager: z.string().email(),
    createdAt: z.string().datetime(),
});

const ProductSchema = z.object({
    transport: TransportSchema,
    material: MaterialSchema.nullable(),
});

const ProjectPositionSchema = z.object({
    positionNumber: z.string().trim().nonempty(),
    costCenter: z.string().optional(),
    status: TrentStatusSchema,
    validFrom: z.string().datetime(),
    validTo: z.string().datetime(),
    location: LocationSchema,
    products: ProductSchema,
});

export const TrentProjectInputSchema = z.object({
    project: ProjectSchema,
    projectPositions: z.array(ProjectPositionSchema).length(1),
});

export type TrentProjectInputRequest = z.infer<typeof TrentProjectInputSchema>;
export type TrentProjectInputTransportRequest = z.infer<typeof TransportSchema>;
export type TrentProjectInputMaterialRequest = z.infer<typeof MaterialSchema>;
